export default function ChangeUrlServiceProvider() {
  this.$get = ($location, $rootScope, $security, $metaInfo, $window) => {
    'ngInject';

    function ChangeUrlService() {

      const self = this;
      const noScrollPages = []; //Don't scroll for search location pages

      $rootScope.$on('$locationChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
        const path = $location.path();
        const url = $location.url();
        let scroll = true;

        for (let l = 0; l < noScrollPages.length; l++) {
          if (url.indexOf(noScrollPages[l]) >= 0) {
            scroll = false;
            break;
          }
        }

        if (scroll) {
          $window.scrollTo(0, 0);
        }

        $metaInfo.change(url, path);
      });
    }

    return new ChangeUrlService();
  };
}